import React, { useEffect, useState } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";

import Index from "./pages/Index";
import WebsiteCursor from "./components/WebsiteCursor";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import DummyPage from "./pages/DummyPage";
import celebration from "./assets/img/icons8-celebration.gif";
import firework from "./assets/img/icons8-firework-explosion.gif";
import Services from "./pages/Services";

function App() {
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowPopup(false);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  const closePopup = () => {
    setShowPopup(false);
  };

  return (
    <>
      <WebsiteCursor />
      <div className="back_wall">
        <div className="row">
          <div className="col-3 borderLines"></div>
          <div className="col-3 borderLines"></div>
          <div className="col-3 borderLines"></div>
          <div className="col-3 borderLines"></div>
        </div>
      </div>
      {showPopup && (
        <div className="popup animated">
          <div className="popup-close" onClick={closePopup}>
            <i className="fa fa-close" />
          </div>
          <div className="popup-content">
            <h5 className="first-heading">
              Buy a service at a discounted price and score loads of FREE
              services!
            </h5>
            <div className="images_celebration"></div>
            <h6 className="second-heading">
              <b>
                <img src={firework} alt="" />{" "}
                <span className="blink">Only A Week Left </span>
                <img src={firework} alt="" /> <br /> Don't Let It Slip Away!
              </b>
            </h6>
            <p className="deals_heading">
              EXCLUSIVE DEALS <img src={celebration} alt="" />
            </p>
            <div className="animation">
              <span>Website Developement</span> <span>Logo </span>{" "}
              <span>Blogs</span>
            </div>
            <div className="claim_btn mt-4">
              <a href="https://wa.me/447577842671">
                <button>Claim Your Spot Now</button>
              </a>
            </div>
          </div>
        </div>
      )}
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/privacypolicy" element={<PrivacyPolicy />} />
            <Route path="/Services" element={<Services />} />
            <Route path="/dummypage" element={<DummyPage />} />
          </Routes>
        </BrowserRouter>
      </div>

      {/* <Index /> */}
    </>
  );
}

export default App;
